import { render, staticRenderFns } from "./HeaderAuthMain.vue?vue&type=template&id=0c668b9e&"
import script from "./HeaderAuthMain.vue?vue&type=script&lang=js&"
export * from "./HeaderAuthMain.vue?vue&type=script&lang=js&"
import style0 from "./HeaderAuthMain.vue?vue&type=style&index=0&id=0c668b9e&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports